import React from 'react';

function LoaderComponent(props) {
  return (
    <div className="loader">
	  <div></div>
	  <div></div>
	  <div></div>
	</div>
  );
}

export default LoaderComponent;
